import {
  GET_LIST,
  GET_MANY,
  GET_ONE,
  GET_MANY_REFERENCE,
  CREATE,
  UPDATE,
  DELETE,
  fetchUtils
} from "react-admin";
import { orgsFields } from "./orgs.model";
import queryString from 'query-string';

import { getApiUrlForResource } from '../services/apiUrlResolver';
import logger from '../utils/logger';
export const ORGANIZATIONS_RESOURCE_NAME = "organizations";

// Helper function to get API URL at request time
const getApiUrl = () => getApiUrlForResource(ORGANIZATIONS_RESOURCE_NAME);
//used to fetch all records without paging
export const ALL_ORGANIZATIONS_RESOURCE_NAME = "all.organizations";

export const PUT_MEDICAID = "PUT_MEDICAID";
export const DEACTIVATE_ORGANIZATION = "DEACTIVATE_ORGANIZATION";

const pagedProviderRequestToHttpRequest = (requestType, requestParams) => {
  return providerRequestToHttpRequest(requestType, requestParams, false);
};

const allProviderRequestToHttpRequest = (requestType, requestParams) => {
  let result = providerRequestToHttpRequest(requestType, requestParams, true);
  return result;
};

const providerRequestToHttpRequest = (requestType, requestParams, all) => {
  switch (requestType) {
    case GET_LIST:
      return composeGetOrgsListRequest(requestParams, all);
    case GET_ONE:
      if (requestParams.id.toString().includes('/product_features')) {
        return {
          url: `${getApiUrl()}/${ORGANIZATIONS_RESOURCE_NAME}/${requestParams.id}`,
        };
      }
      return {
        url: `${getApiUrl()}/${ORGANIZATIONS_RESOURCE_NAME}/${requestParams.id}`,
      };
    case GET_MANY: {
      const query = {
        filter: JSON.stringify({
          id: requestParams.ids,
        }),
      };
      return {
        url: `${getApiUrl()}/${ORGANIZATIONS_RESOURCE_NAME}?${queryString.stringify(query)}`,
      };
    }
    case GET_MANY_REFERENCE: {
      const { page, perPage } = requestParams.pagination;
      const { field, order } = requestParams.sort;
      const query = {
        sort: JSON.stringify([field, order]),
        range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
        filter: JSON.stringify({
          ...requestParams.filter,
          [requestParams.target]: requestParams.id,
        }),
      };
      return {
        url: `${getApiUrl()}/${ORGANIZATIONS_RESOURCE_NAME}?${queryString.stringify(query)}`,
      };
    }
    case UPDATE:
      if (requestParams.id.toString().includes('/product_features')) {
        return {
            url: `${getApiUrl()}/${ORGANIZATIONS_RESOURCE_NAME}/${requestParams.id}`,
            options: {
                method: 'PUT',
                body: JSON.stringify(requestParams.data),
            },
        };
      }
      return {
        url: `${getApiUrl()}/${ORGANIZATIONS_RESOURCE_NAME}/${requestParams.id}`,
        options: {
          method: "PUT",
          body: JSON.stringify({
            ...requestParams.data,
            [orgsFields.enrollmentMethod]: requestParams.data[orgsFields.enrollmentMethod] === 'none' ? null : requestParams.data[orgsFields.enrollmentMethod],
          }),
        },
      };
    case CREATE:
      return {
        url: `${getApiUrl()}/${ORGANIZATIONS_RESOURCE_NAME}`,
        options: {
          method: "POST",
          body: JSON.stringify({
            ...requestParams.data,
            [orgsFields.enrollmentMethod]: requestParams.data[orgsFields.enrollmentMethod] === 'none' ? null : requestParams.data[orgsFields.enrollmentMethod],
          }),
        },
      };
    case DELETE:
      return {
        url: `${getApiUrl()}/${ORGANIZATIONS_RESOURCE_NAME}/${requestParams.id}`,
        options: {
          method: "DELETE",
        },
      };
    case PUT_MEDICAID:
      // logger.log("Organizations ", "PUT_MEDICAID");
      // logger.log("Organizations id: ", requestParams.id);
      // logger.log(JSON.stringify(requestParams));

      const body =
        requestParams.action === "processUploadedCsv"
          ? {
              action: "processUploadedCsv",
              s3FileKey: requestParams.s3FileKey,
              orgId: requestParams.id,
              dateSent: requestParams.dateSent,
            }
          : requestParams;
     

      return {
        url: `${getApiUrl()}/${ORGANIZATIONS_RESOURCE_NAME}/${requestParams.id}/marketing`,
        options: {
          method: "PUT",
          body: JSON.stringify(body),
        },
      };
    case DEACTIVATE_ORGANIZATION:
      return {
        url: `${getApiUrl()}/${ORGANIZATIONS_RESOURCE_NAME}/${requestParams.id}/deactivate`,
        options: {
          method: "PUT"
        },
      }

    default:
      throw new Error(`Unsupported fetch action type ${requestType}`);
  }
};

const httpResponseToProviderData = (
  httpResponse,
  requestType,
  requestParams
) => {
  let { headers, json } = httpResponse;
  switch (requestType) {
    case GET_LIST:
      return {
        data: json.map((organizationItem) => organizationItem),
        total: parseInt(headers.get("content-range").split("/").pop()),
      };
    case GET_MANY:
      let organizationIdsToGet = requestParams.ids;
      return {
        data: json.filter((organizationItem) =>
          organizationIdsToGet.includes(organizationItem.id)
        ),
      };
    case GET_ONE:
      if (requestParams.id && requestParams.id.toString().includes('/product_features')) {
        // Special handling for product features endpoint
        return { data: { ...json, id: requestParams.id } };
      }
      return {
        data: json,
      };
    case CREATE:
    case UPDATE:
      if (requestParams.id && requestParams.id.toString().includes('/product_features')) {
        return { data: { ...json, id: requestParams.id } };
      }
      return {
        data: {
          ...requestParams.data,
          id: json.id,
          [orgsFields.enrollmentMethod]: requestParams.data[orgsFields.enrollmentMethod] === 'none' ? null : requestParams.data[orgsFields.enrollmentMethod],
        },
      };
    default:
      return {
        data: json,
      };
  }
};

const composeGetOrgsListRequest = (requestParams, all) => {
  const { page, perPage } = requestParams.pagination;
  const { field, order } = requestParams.sort;
  let prepareFilters = () => {
    let requestFilters = requestParams.filter;
    if (requestFilters === undefined) {
      return {};
    }
    let createContainsFilter = (name, value) => ({
      name,
      comparison: "contains",
      value,
    });

    let createEqFilter = (name, value) => ({
        name,
        comparison: "eq",
        value
    });

    let createIsNullFilter = (name) => ({
        name,
        comparison: "isnull"
    });

    let createIsNotNullFilter = (name) => ({
        name,
        comparison: "notnull"
    });

    let createDateBetweenFromFilter = (name, value) => ({
      name,
      comparison: "betweenFrom",
      value,
    });
    let createDateBetweenToFilter = (name, value) => ({
      name,
      comparison: "betweenTo",
      value,
    });

    let resultFilters = [];

    // append "name" filter
    if (requestFilters.hasOwnProperty(orgsFields.orgName)) {
      resultFilters.push(
        createContainsFilter("orgName", requestFilters[orgsFields.orgName])
      );
    }
    // append "wicId" filter
    if (requestFilters.hasOwnProperty(orgsFields.requiresWicId)) {
      resultFilters.push(createEqFilter('requiresWicId', requestFilters[orgsFields.requiresWicId] ? 1 : 0));
    }
    // append "enrollmentCodeRequired" filter
    if (requestFilters.hasOwnProperty(orgsFields.enrollmentCodeRequired)) {
      resultFilters.push(createEqFilter('enrollmentCodeRequired', requestFilters[orgsFields.enrollmentCodeRequired] ? 1 : 0));
    }
    // append "contentLibraryEnabled" filter
    if (requestFilters.hasOwnProperty(orgsFields.contentLibraryEnabled)) {
      resultFilters.push(createEqFilter('contentLibraryEnabled', requestFilters[orgsFields.contentLibraryEnabled] ? 1 : 0));
    }
    // append "nursePhone" filter
    if (requestFilters.hasOwnProperty(orgsFields.nursePhone)) {
      if (requestFilters[orgsFields.nursePhone] === true) {
        resultFilters.push(createIsNotNullFilter('nursePhone'));
      } else {
        resultFilters.push(createIsNullFilter('nursePhone'));
      }
    }

    
    // append "created at" filter
    if (requestFilters.hasOwnProperty("createdBetween")) {
      let between = requestFilters["createdBetween"];
      // logger.log("created at from between: ", between);
      if (between.gte != null) {
        // logger.log("created at from between.gte: ", between.gte);
        resultFilters.push(
          createDateBetweenFromFilter("createdAtFrom", between.gte)
        );
      }
      if (between.lte != null) {
        // logger.log("created at to between.lte: ", between.lte);
        resultFilters.push(
          createDateBetweenToFilter("createdAtTo", between.lte)
        );
      }
    }
    // append "updated at" filter
    if (requestFilters.hasOwnProperty("updatedBetween")) {
      let between = requestFilters["updatedBetween"];
      // logger.log("updated at from endedBetween: ", between);
      if (between.gte != null) {
        // logger.log("updated at from between.gte: ", between.gte);
        resultFilters.push(
          createDateBetweenFromFilter("updatedAtFrom", between.gte)
        );
      }
      if (between.lte != null) {
        // logger.log("updated at to between.lte: ", between.lte);
        resultFilters.push(
          createDateBetweenToFilter("updatedAtTo", between.lte)
        );
      }
    }
    return resultFilters;
  };

  const queryParams = {
    all: all,
    sort: JSON.stringify([field, order]),
    range: JSON.stringify([(page - 1) * perPage, page * perPage]),
    filters: JSON.stringify(prepareFilters()),
  };
  return {
    url: `${getApiUrl()}/${ORGANIZATIONS_RESOURCE_NAME}?${queryString.stringify(queryParams)}`,
  };
};

export default {
  resource: ORGANIZATIONS_RESOURCE_NAME,
  providerInterface: {
    providerRequestToHttpRequest: pagedProviderRequestToHttpRequest,
    httpResponseToProviderData
  }
};

export const allOrganizationsDataProvider = {
  resource: ALL_ORGANIZATIONS_RESOURCE_NAME,
  providerInterface: {
    providerRequestToHttpRequest: allProviderRequestToHttpRequest,
    httpResponseToProviderData,
  },
};
